import axios from '../../../axios';
import { CVLibrarySearch } from '../types/CVLibrarySearch';

export const searchCVLibrary = async (query: CVLibrarySearch) =>
  await axios.post('/candidatesearch/api/cv-library/search', query);

export const getCVLibraryLocations = (searchKey: string) =>
  axios.get(`/candidatesearch/api/cvlibrarylocations/get-locations?query=${searchKey}`);
